import { useToastContext } from "components/alert/ToastContext";
import { useFilter } from "contexts/FilterContext";
import { BaseModel } from "model/BaseModel";
import MovimentoEstoquePratico from "model/integracao/pratico/MovimentoEstoquePratico";
import Pageable from "model/page/Pageable";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import MovimentoPraticoService from "service/integracao/MovimentoPraticoService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { converterData, converterDataHora } from "utils/convert";
import { dateRangeFilterTemplate, decimalFilterTemplate, dropdownFilterTemplate, filterApplyTemplate, IdMatchModeOptions, NumberMatchModeOptions, TextMatchModeOptions } from "utils/filterUtils";

const movimentoPraticoService = new MovimentoPraticoService();
const usuarioLogadoService = new UsuarioLogadoService();
export default function IntegracaoMovimentoListagem() {

    const { msgErro } = useToastContext();

    const { startLoading, stopLoading } = useLoadingContext();

    const [tableLoading, setTableLoading] = useState<boolean>(false);

    const defaultFilters = {
        numeroMovimento: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        datamov: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        tipoMovimento: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        cdProduto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        loteProducao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        descNivel: {
            constraints: [
                {
                    value: "",
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        estoque: {
            constraints: [
                {
                    value: "",
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        numeroOp: {
            constraints: [
                {
                    value: "",
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        msgErro: {
            constraints: [
                {
                    value: "",
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        quantidade: {
            constraints: [
                {
                    value: "",
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const filterContext = useFilter();
    const screen = "IntegracaoMovimentoListagem";

    const [pageable, setPageable] = useState(new Pageable(0, 10, "dataMovimento,desc", 0));
    const [list, setList] = useState<BaseModel[]>([]);
    const [totalElements, setTotalElements] = useState<number>(0);
    const [podeReexecutar, setPodeReexecutar] = useState<boolean>(false);

    const [filters, setFilters] = useState<DataTableFilterMeta>(filterContext.filters[screen] ? filterContext.filters[screen] : defaultFilters);

    const numberTemplate = (rowData: any, options: any) => {
        if (rowData[options.field] === null || rowData[options.field] === undefined) {
            return "";
        }
        return new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(rowData[options.field]);
    };

    const { msgAlerta, msgSucesso } = useToastContext();

    useEffect(() => {
        buscar();
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            setPodeReexecutar(usuarioLogadoService.usuarioTemAcao(resposta, "INTEGRACAO_PRATICO_MOVIMENTO_REEXECUTAR"));
        }).catch((erro) => {
            console.log(erro);
        });
    }, [pageable, filters]);

    function buscar() {
        filterContext.updateFilters(screen, filters);
        setTableLoading(true);
        movimentoPraticoService.pesquisar(pageable, filters).then((response) => {
            setList(response.content);
            setTotalElements(response.totalElements);
            setTableLoading(false);
        }).catch((error) => {
            console.log(error);
            setTableLoading(false);
        });
    }

    const clearFilter = () => {
        setFilters(defaultFilters || {});
    }

    const reexecutar = (movimento: MovimentoEstoquePratico) => {
        movimentoPraticoService.reexecutar(movimento).then((response) => {
            msgSucesso("Enviado", "Movimento enviado para reexecução.");
            buscar();
        }).catch((error) => {
            msgErro("Erro", error.response.data.message);
        });
    }

    return (
        <DataTable
            loading={tableLoading}
            filters={filters}
            onFilter={(e) => setFilters(e.filters)}
            header={<div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                <span style={{ textAlign: 'center', width: "100%", alignSelf: "center", position: 'relative' }}>Movimentações de estoque</span>
                <div style={{ display: "flex" }}>
                    <Button type="button" icon="pi pi-filter-slash" label="Limpar" outlined onClick={clearFilter} style={{ marginRight: 8 }} />
                </div>
            </div>}
            value={list}
            scrollable
            emptyMessage="Nenhum registro encontrado"
            first={pageable.first} rows={10} lazy
            paginator={true} totalRecords={totalElements}
            onPage={(event) => {
                setPageable({ ...pageable, page: event.page !== undefined ? event.page : 0, first: event.first });
            }}
        >
            <Column field="numeroMovimento" header="Nr. Movimento" style={{ minWidth: "100px" }} filter showFilterOperator={false} showAddButton={false} filterElement={decimalFilterTemplate}
                filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="datamov" header="Data" body={(rowData) => converterData(rowData.datamov)} style={{ minWidth: "160px" }} filter showFilterOperator={false}
                showAddButton={false} filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }} />
            <Column field="tipoMovimento" header="Tipo" body={(rowData) => movimentoPraticoService.getTipoMovimento(rowData.tipoMovimento)} style={{ minWidth: "100px" }}
                filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate}
                filterElement={(options) => dropdownFilterTemplate(options, [{ label: "Entrada", value: "E" }, { label: "Saída", value: "S" }], "label", "value")} />
            <Column field="cdProduto" header="Cód. Produto" style={{ minWidth: "75px" }}
                filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="descNivel" header="Lote" style={{ minWidth: "100px" }}
                filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="estoque" header="Cód. estoque" style={{ minWidth: "75px" }}
                filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="msgErro" header="Erro" style={{ minWidth: "100px" }}
                filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="quantidade" header="Quantidade" style={{ minWidth: "115px" }} body={numberTemplate}
                filter showFilterOperator={false} showAddButton={false} filterElement={decimalFilterTemplate} filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} />
            {podeReexecutar ? <Column body={(rowData) => <Button icon="pi pi-play" label="Reexecutar" onClick={() => { reexecutar(rowData) }} />} style={{ width: "50px" }} /> : null}
        </DataTable>
    );
}